import { render, staticRenderFns } from "./ExportDocuments.vue?vue&type=template&id=a72bd842&scoped=true&"
import script from "./ExportDocuments.vue?vue&type=script&lang=js&"
export * from "./ExportDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ExportDocuments.vue?vue&type=style&index=0&id=a72bd842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72bd842",
  null
  
)

export default component.exports